<header class="o-widget__header">
  <h1 class="o-widget__heading">Meine Aufgaben</h1>
  <p class="o-widget__subline">Fällige Objekte, denen man zugeordnet ist</p>
</header>
<div class="o-widget__body">
  <p>Absprung in den Workspace</p>
</div>
